<section class="pt-16 pb-8 px-container">
    <app-breadcrumb-backoffice [items]="[{ label: 'Home', route: '/backoffice/home' }, { label: 'Vouchers', route: '/backoffice/vouchers/' }, { label: 'Modifica Voucher', active: true }]"></app-breadcrumb-backoffice>
    <h1 class="lg:text-4xl text-2xl font-mono text-center uppercase">MODIFICA VOUCHER</h1>
</section>


<section class="pb-16 mb-8 px-container">
    <form [formGroup]="formVoucher" (ngSubmit)="onSubmit()">
        <div class="flex flex-col gap-8">                                                                
            <div class="flex lg:flex-row flex-col gap-8">
                <div class="lg:w-1/3 w-full">
                    <label>* Cliente</label>
                    <input type="text" pInputText formControlName="cliente" required/>
                    <small class="text-red-600 block mt-4 font-medium" *ngIf="formVoucher.get('cliente')?.hasError('required') && (formVoucher.get('cliente')?.dirty || formVoucher.get('cliente')?.touched)">Il cliente è obbligatorio!.</small>
                </div>
                <div class="lg:w-1/3 w-full">
                    <label>Email</label>
                    <input type="email" pInputText placeholder="Email" formControlName="email" name="email" id="email" />                    
                    <small class="text-red-600 block mt-4 font-medium" *ngIf="formVoucher.get('email')?.hasError('email') && (formVoucher.get('email')?.dirty || formVoucher.get('email')?.touched)">L'email deve essere valida!.</small>
                </div>    
                <div class="lg:w-1/3 w-full">
                    <label>Telefono</label>
                    <input type="text" pInputText formControlName="telefono" />
                </div>
            </div>  
            <div class="flex lg:flex-row flex-col gap-8">
                <div class="lg:w-1/3 w-full flex flex-col">
                    <label>* Credito</label>
                    <p-inputNumber formControlName="credito" mode="currency" currency="EUR" locale="it-IT" [maxFractionDigits]="2"  class="w-full"/>
                    <small class="text-red-600 block mt-4 font-medium" *ngIf="formVoucher.get('credito')?.hasError('required') && (formVoucher.get('credito')?.dirty || formVoucher.get('credito')?.touched)">Il credito è obbligatorio!.</small>
                </div>   
                <div class="lg:w-1/3 w-full">
                    <label>* Codice</label>
                    <input type="text" pInputText formControlName="codice" />
                    <small class="text-red-600 block mt-4 font-medium" *ngIf="formVoucher.get('codice')?.hasError('required') && (formVoucher.get('codice')?.dirty || formVoucher.get('codice')?.touched)">Il codice è obbligatorio!.</small>
                </div>
                <div class="lg:w-1/3 w-full">
                    <label>Data scadenza</label>
                    <p-calendar formControlName="data_scadenza" dateFormat="dd/mm/yy" [showIcon]="true" />
                </div>
            </div>                                                                            
            <div class="flex lg:flex-row flex-col gap-8">
                <div class="lg:w-1/2 w-full">
                    <button class="btn-outln-backoffice p-3 w-full font-medium" type="submit" [disabled]="!formVoucher.valid">Modifica voucher</button>
                </div>
                <div class="lg:w-1/2 w-full">
                    <p-confirmPopup #confirmDeletePopupRef>
                        <ng-template pTemplate="headless" let-message>
                            <div class="border-round p-3">
                                <span class="text-base">{{ message.message }}</span>
                                <div class="flex align-items-center gap-2 mt-3">
                                    <p-button class="text-center btn-danger-backoffice p-2 w-full font-medium" (click)="onDelete()" label="Elimina" />
                                    <p-button class="text-center btn-outln-backoffice p-2 w-full font-medium" (click)="onAnnulla()" label="Annulla" />
                                </div>
                            </div>
                        </ng-template>
                    </p-confirmPopup>
                    <button class="btn-danger-backoffice p-3 w-full font-medium" type="button" (click)="onDeleteVoucherPopup($event)">Elimina voucher</button>
                </div>
            </div>    
        </div>
    </form>
</section>